import {
  Box,
  Divider,
  ListItemIcon,
  ListItemText,
  MenuItem,
  MenuList,
  Typography,
} from '@mui/material';
import {
  AyudaMenuListMobile,
  BottomMenuList,
  SideMenuList,
  SideMenuListCapitado,
  SideMenuListNoCapitado,
  UserMenuListMobile,
} from '../../routes/Menu';
import { useEffect, useState } from 'react';
import { useInfoAfiliado } from '../../components/Afiliados/InfoAfiliadoProvider';
import { NavLink } from 'react-router-dom/cjs/react-router-dom.min';
import ButtonDownloadPWA from '../../@iosper/components/PWA/ButtonDownloadPWA';
import { BotonDescargaApp } from '../../components/Auth/components/BotonDescargaApp';
import { ButtonDownloadPWAiOS } from '../../@iosper/components/PWA/ButtonDownloadPWAiOS';
import { VerifiedRounded } from '@mui/icons-material';
import { useVersionControlStore } from '../../@iosper/components/VersionControl/store/hooks';

const drawMenuList = (list) => {
  return list.map((item) => (
    <MenuItem key={item.to} component={NavLink} to={item.to} activeClassName='Mui-selected' exact>
      <ListItemIcon sx={{ color: 'default.main' }}>{item.icon}</ListItemIcon>
      <ListItemText>{item.label}</ListItemText>
    </MenuItem>
  ));
};

export const MenuMobilePage = () => {
  const [esCapitado, setCapitado] = useState(false);
  const { infoAfiliado } = useInfoAfiliado();
  const { state } = useVersionControlStore();
  const colorVersion = () => (state.isUptodate ? 'success.main' : 'warning.main');

  useEffect(() => {
    if (infoAfiliado) {
      // Si trae la fecha de venicmiento es un afiliado capitado
      setCapitado(infoAfiliado != null && infoAfiliado.tipoAfiliado.fechaVencimientoCapita != null);
    } else {
      setCapitado(false);
    }
  }, [infoAfiliado]);

  return (
    <MenuList>
      {drawMenuList(SideMenuList)}
      {esCapitado ? drawMenuList(SideMenuListCapitado) : drawMenuList(SideMenuListNoCapitado)}
      <Divider />
      {drawMenuList(UserMenuListMobile)}
      <Divider />
      {drawMenuList(AyudaMenuListMobile)}
      <Divider />
      {drawMenuList(BottomMenuList)}
      <Divider />
      <Box sx={{ mb: 3 }} />
      {/* Botón Descargar App */}
      <ButtonDownloadPWA>
        <BotonDescargaApp
          arialLabel={'Instalar Aplicación. Acceso rápido desde tu pantalla de inicio.'}
          content={
            <Typography variant='body2'>
              <b>Instalar Aplicación</b> <br />
              Acceso rápido desde tu pantalla de inicio.
            </Typography>
          }
        />
      </ButtonDownloadPWA>
      <ButtonDownloadPWAiOS isMobile>
        <BotonDescargaApp
          arialLabel={'¿Cómo instalar mi.OSER en dispositivos Apple?'}
          content={
            <Typography variant='body2'>
              ¿Cómo <b>Instalar Aplicación</b>? <br />
              Acceso rápido desde tu pantalla de inicio.
            </Typography>
          }
        />
      </ButtonDownloadPWAiOS>

      <MenuItem key={'version'} sx={{ mt: 1 }}>
        <ListItemIcon sx={{ color: colorVersion }}>
          <VerifiedRounded />
        </ListItemIcon>
        <ListItemText>
          <Typography variant='body2' sx={{ color: colorVersion }}>
            {`Versión ${process.env.REACT_APP_MI_IOSPER_VERSION} ${
              process.env.REACT_APP_MI_IOSPER_VERSION_BETA_TEXT || ''
            }`}
          </Typography>
        </ListItemText>
      </MenuItem>
    </MenuList>
  );
};
